import React from "react"
import { useReportFormInfo } from "Pages/ReportsAlerts/Reports/@hooks"
import { reportFormData } from "Pages/ReportsAlerts/Reports/@signals"
import { array, object } from "yup"
import { AppAsyncOfficesAutocomplete } from "@components"

const ONE_WAY_ROUTES_ERROR = "Must provide a one way route"

export default function OneWayRoutesField() {

	const {
		oneWayRoutes,
		setOneWayRoutesInfo,
		error
	} = useReportFormInfo(
		reportFormData.peek().oneWayRoutes,
		"oneWayRoutes",
		object({ oneWayRoutes: array().required(ONE_WAY_ROUTES_ERROR).min(1, ONE_WAY_ROUTES_ERROR) })
	)

	return <AppAsyncOfficesAutocomplete
		multiple
		label="One Way Office Routes"
		placeholder="Select One Way Office Routes"
		value={oneWayRoutes || []}
		error={error}
		onChange={e => setOneWayRoutesInfo(e.target.value)}
	/>
}
